// extracted by mini-css-extract-plugin
export var component = "ModuleWrapper-module--component--W7iGr";
export var header = "ModuleWrapper-module--header--AJnHl";
export var title = "ModuleWrapper-module--title--3ezVO";